export const passwordChange = {
    sendOTP: null,
    password: null,
}